import userBuildGraphQLProvider from 'ra-data-graphql-simple'
import adminBuildGraphQLProvider from 'ra-data-graphql-simple'

import apolloClient from 'clients/apollo'
import apolloAdminClient from 'clients/apollo/admin'
import customBuildQuery from 'dash/custom_build_query'
import { introspectSchema } from './introspection'
// import mockDataProvider from './mock'

// let resourcesToMock = process.env.MOCKED_RESOURCES.length > 0 ? process.env.MOCKED_RESOURCES.split(',') : []

export async function buildCompositeGraphQLProvider() {
  const dataProvider = await userBuildGraphQLProvider({
    buildQuery: customBuildQuery,
    client: apolloClient,
    introspection: {
      operationNames: {}, // this was included to avoid a ts error, not sure why it's required in the ra-data-graphql-simple IntrospectionOptions type
      include: ['CurrentUser'], // resources we want included that don't implement the required GET_ONE & GET_MANY react-admin actions
    },
    resolveIntrospection: introspectSchema('user'),
  })

  const adminDataProvider = await adminBuildGraphQLProvider({
    buildQuery: customBuildQuery,
    client: apolloAdminClient,
    introspection: {
      operationNames: {}, // this was included to avoid a ts error, not sure why it's required in the ra-data-graphql-simple IntrospectionOptions type
      include: ['CurrentUser'], // resources we want included that don't implement the required GET_ONE & GET_MANY react-admin actions
    },
    resolveIntrospection: introspectSchema('admin'),
  })

  return new CompositeDataProvider({
    user: {
      provider: dataProvider,
      handlesResource: (resource) => true, // this is a default
    },
    admin: {
      provider: adminDataProvider,
      handlesResource: (resource) => resource.startsWith('admin/'),
    },
    // mock: {
    //   provider: mockDataProvider,
    //   handlesResource: (resource) => resourcesToMock.find(r => resource.endsWith(r)) != null
    // }
  })
}

type CompositeDataProviderConstructorType = {
  user: any
  admin: any
  // mock: any
}

class CompositeDataProvider {
  adminDataProvider: any
  // mockDataProvider: any;
  userDataProvider: any

  // subscriptions = []

  constructor(providers: CompositeDataProviderConstructorType) {
    // this.mockDataProvider = providers.mock
    this.userDataProvider = providers.user
    this.adminDataProvider = providers.admin
  }

  _delegate(name, resource, params) {
    // if(this.mockDataProvider.handlesResource(resource)){
    //   return this.mockDataProvider.provider[name](resource.replace('admin/', '').replace('user/', ''), params) // handles admin and user resources
    // } else
    if (this.adminDataProvider.handlesResource(resource)) {
      return this.adminDataProvider.provider[name](resource, params)
    }
    return this.userDataProvider.provider[name](resource, params)
  }

  getList(resource, params) {
    return this._delegate('getList', resource, params)
  }
  getOne(resource, params) {
    return this._delegate('getOne', resource, params)
  }
  getMany(resource, params) {
    return this._delegate('getMany', resource, params)
  }
  getManyReference(resource, params) {
    return this._delegate('getManyReference', resource, params)
  }
  create(resource, params) {
    return this._delegate('create', resource, params)
  }
  update(resource, params) {
    return this._delegate('update', resource, params)
  }
  updateMany(resource, params) {
    return this._delegate('updateMany', resource, params)
  }
  delete(resource, params) {
    return this._delegate('delete', resource, params)
  }
  deleteMany(resource, params) {
    return this._delegate('deleteMany', resource, params)
  }
  // async subscribe (topic, subscriptionCallback){
  //   this.subscriptions.push({ topic, subscriptionCallback });
  //   console.log('subscribe', this.subscriptions)
  //   return Promise.resolve({ data: null });
  // }
  // async unsubscribe(topic, subscriptionCallback) {
  //   this.subscriptions = this.subscriptions.filter(
  //     (subscription) =>
  //       subscription.topic !== topic ||
  //       subscription.subscriptionCallback !== subscriptionCallback
  //   );
  //   console.log('unsubscribe', this.subscriptions)
  //   return Promise.resolve({ data: null });
  // }
  // publish (topic, event) {
  //   console.log('publish', topic, event)
  //   if (!topic) {
  //     return Promise.reject(new Error("ra-realtime.error.topic"));
  //   }
  //   if (!event.type) {
  //     return Promise.reject(new Error("ra-realtime.error.type"));
  //   }
  //   this.subscriptions.map(
  //     (subscription) =>
  //       topic === subscription.topic && subscription.subscriptionCallback(event)
  //   );
  //   return Promise.resolve({ data: null });
  // }
}
